import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const StyledContactButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
  '&.Mui-disabled': {
    color: theme.palette.common.white,
    opacity: 0.4,
  },
  padding: theme.spacing(0.5),
}));

export const StyledPhoneIcon = styled(PhoneEnabledOutlinedIcon)(() => ({
  fontSize: '1rem',
}));

export const StyledEmailIcon = styled(EmailOutlinedIcon)(() => ({
  fontSize: '1rem',
}));

export const DisabledTooltipWrapper = styled('span')(() => ({}));
